import styles from './MnpItem.module.css'
import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ReduxStateInt, setBaseRegion, setOrderData, setSlider} from "../../Reducer/GlobalReducer";
import InputItem from "../../FormTemplate/InputItem/InputItem";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import WaitLoader from "../../WaitLoader/WaitLoader";
import {useIsMobile} from "../../Util/CheckMobile";
interface ICtnItem {
    text:string
    ctn:string
    valid:boolean
}
export default function MnpItem()
{
    const [mode,setMode] = useState(0)
    const vidWidth =  window.innerWidth-60 < 720 ? window.innerWidth-60 : 500
    const [useMnp, setUseMnp] = useState(false)
    const refMainCont = useRef<HTMLDivElement>(null)
    const isMobile = useIsMobile()

    const [opsMain, setOpsMain] = useState(false)

    const [showWarning, setShowWarning] = useState(true)

    const navigate = useNavigate()
    const dispatch = useDispatch();
    const location = useLocation()
    const [ctnItem,setCtnItem] = useState<ICtnItem>({
        ctn:"",
        text:"",
        valid:false
    })

    const mnpData = useRef<{
        ctn:string
        tarifId:string
    }>()

    const [ldrMnpData,rsMnpData,exMnpData] = useApiQuery("/tarif/mnp/ctn/check","post",mnpData);
    const [mnpCheckResult,setMnpCheckResult] = useState<{
        mnpAvailable: boolean
        text: string
        reason?:string
        sameOper: boolean
        srcOper?:string
        srcRegion?:string
    }|undefined>(undefined)



    const slider = useSelector((state: ReduxStateInt) => {
        return state.slider
    })

    const baseRegion = useSelector((state: ReduxStateInt) => {
        return state.baseRegion
    })

    const prefDomain = useSelector((state: ReduxStateInt) => {
        return state.prefDomain
    })

    useEffect(()=>{ //Блокируем переход без данных
        if(! location || !slider) return
        if(slider?.dataCardItem?.tarifId === undefined || slider?.selectedTarif?.length === 0)handleMoveHomeSlide()
        resolveMnpUse(slider?.dataCardItem?.bundleOne?.regionMnpList)
        if(refMainCont.current)refMainCont.current.scrollIntoView()



    },[location])




    useEffect(()=>{
        if(! baseRegion)return
        if(!baseRegion?.isChanged)
        {
            setMode(1) //Выбрать  регион
            return
        }
        setMode(0)//Выбран регион
        resolveMnpUse(slider?.dataCardItem?.bundleOne?.regionMnpList)
    },[baseRegion])

    useEffect(()=>{
        if(mnpCheckResult && mnpCheckResult?.mnpAvailable)
        {
            setOpsMain(true)
            return
        }
        setOpsMain(false)
    },[mnpCheckResult])

    const resolveMnpUse = (mnpRegionList: string) => {
        if(! mnpRegionList) //Если нет никакой возможности mnp то не показываем вообще
        {
            setUseMnp(false)
            setMode(2)
            return;
        }

        if(slider?.dataCardItem?.useMNP !== undefined && !slider?.dataCardItem?.useMNP) //Если в самой карточке запрет на mnp не важно из каких регионов
        {
            setMode(2)
            setUseMnp(false)
            return;
        }


        const x  = mnpRegionList?.split(';')

        const match = x?.filter((item)=>{
            if(item?.match(/all/ui)) return true
            if(baseRegion?.isChanged)
            {
                const m1 = new RegExp("^"+baseRegion?.macroRegionId+"$","ui")
                const m2 = new RegExp("^"+baseRegion?.regionId+"$","ui")
                if(item?.match(m1) || item?.match(m2)) return  true

            }
            return  false

        })
        setMode( match?.length > 0 ? 0 : 2)
        setUseMnp(match?.length > 0)

    }


    const handleMoveHomeSlide = () =>{
        dispatch(setSlider({sliderMode:0}))
        window.scrollTo({
            top:0
        })
        navigate('/')
    }

    const buildSelectRegion = ()=>{
        if(mode !==1) return null
        return (
            <>
                <p className={styles.mnpRegTitle}>
                    Для продолжения работы нужно Выбрать регион Вашего нахождения, от этого зависит возможность проведения процедуры портации ( MNP )
                </p>
                <button type="button" className="btn btn-face "
                    onClick={()=>{
                        dispatch(setBaseRegion({...baseRegion,makeSelectRegion: true}))
                    } }
                >Выбрать</button>

            </>
        )


    }

    const handleCheckMnp = () =>{
        setMnpCheckResult(undefined)
        setShowWarning(false)
        mnpData.current={
            ctn:ctnItem?.ctn,
            tarifId: slider?.dataCardItem?.tarifId
        }
        exMnpData().then((e)=>{
            if(e?.success)
            {
                setMnpCheckResult(e?.payload)
                return
            }
            setMnpCheckResult({
                mnpAvailable: false,
                text: e?.errorAsString ? e?.errorAsString : "Ошибка проверки, попробуйте позднее",
                sameOper: false
            })


        })

    }


    const buildTermItem = (name:string, val:string)=>
    {
        return (
            <div className={styles.termLine}>
                <div className={styles.termLineTitle}>{name}</div>
                <div className={styles.termLineVal}>{val}</div>
            </div>
        )
    }

    const buildMnpTerm = () =>{
        return(
            <div className={styles.termCont}>
                {buildTermItem("Оператор тарифа",slider?.dataCardItem?.operOne?.name)}
                {buildTermItem("Тариф",slider?.dataCardItem?.name)}
                {buildTermItem("Регион",baseRegion?.regionName ? baseRegion?.regionName : "-")}
                {ctnItem?.valid && <>{buildTermItem("Номер для портации",ctnItem?.text)}</> }
            </div>
        )
    }

    const buildNoMnp = ()=>{
        if(mode !== 2) return null
        return (
            <>
                <p className={styles.mnpNoTitle}>
                    К сожалению переход на тариф <span>{slider?.dataCardItem?.name}</span> с Вашим номером недоступен для региона <span>{baseRegion?.regionName}</span>.
                    Вы можете выбрать либо новое подключение с этим тарифом и новым номером, либо выбрать другой тариф
                </p>
                <button type="button" className="btn btn-face "
                        onClick={()=>{
                            handleMoveHomeSlide()
                        } }
                >Все тарифы</button>

            </>
        )

    }

    const handleMoveMnp = ()=>{
        if(!ctnItem?.valid) return;
        if(baseRegion?.macroRegionId === undefined || baseRegion?.regionId === undefined )return;
        const exCtn = ctnItem?.ctn


        //console.log("set mnp order data")
        dispatch(setOrderData({
            mnpData:{
                ctn: exCtn,
                macroRegionId: baseRegion?.macroRegionId ,
                regionId: baseRegion?.regionId,
                sameOper: mnpCheckResult?.sameOper !== undefined ? mnpCheckResult?.sameOper : false,
                srcOper:mnpCheckResult?.srcOper ? mnpCheckResult?.srcOper : "-",
                srcRegion: mnpCheckResult?.srcRegion ? mnpCheckResult?.srcRegion : undefined,
            }
        }))
        dispatch(setSlider({...slider, dataCardItem: {...slider?.dataCardItem, regMode:10}}))
        navigate('/order')

    }

    const buildResult = ()=>{
        if(! mnpCheckResult)return null
        if(mnpCheckResult?.mnpAvailable)
        {
            return (
                <div className={styles.rsCont}>

                    <div className={styles.rsBtnCont}>
                        <button type="button" className="btn btn-face "
                                disabled={!ctnItem.valid}
                                onClick={()=>handleMoveMnp()}
                        >Перейти на тариф</button>
                    </div>
                    <div className={styles.rsOkTitle}>{mnpCheckResult?.text}</div>
                    <div className={styles.rsOkReason}>{mnpCheckResult?.reason}</div>
                    {!slider?.dataCardItem?.canSameMNP && <div className={[styles.rsDesc, styles.rsWar].join(' ')}>Нажимая перейти, Вы подтверждаете, что номер {ctnItem?.text} не принадлежит оператору {slider?.dataCardItem?.operOne?.name}</div>}
                    {!mnpCheckResult?.sameOper &&  <div className={[styles.rsDesc, styles.rsWar].join(' ')}>Внимание, оператор «{slider?.dataCardItem?.operOne?.name}» спишет 100 руб. за процедуру перехода - единаразово, при получении временного номера</div>}
                </div>
            )
        }
        return (
            <div className={styles.rsCont}>
                <div className={styles.rsBadTitle}>Номер не может быть портирован</div>
                {mnpCheckResult?.text && <div className={styles.rsDesc}>{mnpCheckResult?.text}</div>}
            </div>
        )
    }


    const buildAnotherWay = ()=>{
        if(!mnpCheckResult) return null
        if(mnpCheckResult?.mnpAvailable) return null
        if(slider?.dataCardItem?.operId?.match(/megafon/ui))
        {
            if(! prefDomain?.mnpFollowMegafon) return null
            if(prefDomain?.mnpFollowMegafon?.match('yota'))
            {
                return (
                    <div className={styles.anCont}>
                        <div>Вам доступны альтернативные варианты от Yota/Megafon</div>
                        <div className={styles.anBtnCont}>
                            <Link to={'https://yota.sim-unlim.com'}>
                                <button type="button" className="btn btn-face"
                                >Ознакомиться</button>

                            </Link>

                        </div>

                    </div>
                )
            }
        }

        return null

    }

    const  buildMnpItem = () =>{
        if(mode !== 0) return null
        const ops = opsMain ? styles.ops : ""
        return (
            <>
                <div className={styles.mnpTitle}>Проверка возможности перехода с Вашим действующим номером</div>
                {showWarning &&
                    <div className={styles.mnpTitleWarn}>! Внимание. Переход с Вашим действующим номером, не с новой сим картой !</div>
                }

                {buildMnpTerm()}
                <div className={[styles.mnpInCont, ops].join(' ')} onClick={()=>setOpsMain(false)}>
                    <div>
                        <InputItem
                            val={ctnItem?.text}
                            mode={"ei"}
                            info={"Ваш номер для перехода"}
                            title={"Ваш номер"}
                            placeHolder={"XXXXXXXXXX"}
                            regExp={/^\+79[0-9]{9}$/ui}
                            maxLen={20}
                            type={"numeric"}
                            onChange={(e)=>{
                                const x = e?.toString()?.replaceAll(/[^0-9+]+/uig,"")
                                if(x.match(/(\+7|8|^)9[0-9]{9}$/ui))
                                {
                                    const px = x?.match(/[0-9]{10}$/ui)
                                    if(px)
                                    {
                                        setCtnItem({
                                            text: `+7${px[0]}`,
                                            valid: true,
                                            ctn: px[0]
                                        })
                                        return
                                    }
                                }
                                setCtnItem({
                                    text: e,
                                    valid: false,
                                    ctn: ""

                                })
                                setMnpCheckResult(undefined)
                            }}
                            //                            onIncorrect={(e)=>setCtnBtnState(true)}
                            exitOnEnter={true}

                        />

                    </div>

                        <div className={styles.mainBtnCnt}>
                            <button type="button" className="btn btn-face"
                                    disabled={!ctnItem.valid}
                                    onClick={()=>handleCheckMnp()}
                            >Проверить</button>
                            <div className={styles.ldrCont}>
                                <WaitLoader loading={ldrMnpData} api={rsMnpData} onlyLoading={true}>

                                </WaitLoader>

                            </div>

                        </div>



                </div>
                {buildResult()}
                {buildAnotherWay()}

                <div className={styles.vidCont}>
                    <div className={styles.vidCapt}>
                        Прежде чем переходить, внимательно просмотрите видео про процесс портации
                        или прочитайте <Link to={'/menu/mnp'} target={"_blank"} className={styles.vidLink}>статью</Link>
                    </div>
                    <iframe width={vidWidth} height={vidWidth/1.77}  src="https://rutube.ru/play/embed/5fdf0aa56503dc265f97163568a3c49b/" style={{border:"none"}} allow="clipboard-write; webkitAllowFullScreen;mozallowfullscreen"   allowFullScreen></iframe>
                </div>
                <div className={styles.rsBtnCont}>
                    <button type="button" className="btn btn-face "
                            onClick={()=>handleMoveHomeSlide()}
                    >Все тарифы</button>
                </div>



            </>
        )
    }

    return(
        <div className={styles.mainCont} ref={refMainCont}>
            <div className={styles.subCont}>
                {buildMnpItem()}
                {buildSelectRegion()}
                {buildNoMnp()}
            </div>

        </div>
    )
}